import React, { useState } from 'react';
import { Badge } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FileNotFound from '../FileNotFound';

const PurchaseOrderPane = props => {
  const { initialPO, list, onChange, isAvailable } = props;
  const [selected, setSelected] = useState(initialPO || '');

  const selectPO = (newPO, threshold) => {
    setSelected(newPO);
    onChange(newPO, threshold);
  };

  const listPOs = () => {
    return list.map(po => {
      const isSelected = po.id === selected;
      const disabled = !isAvailable(po.id) && !isSelected;

      const className = classNames({
        'po-item': true,
        disabled,
      });

      const customer = po.customerName ? ` ${po.customerName}` : '';
      const lineNumber = po.lineNumber ? ` (Line ${po.lineNumber})` : '';
      const createdDate = po.createdDate ? ` [${po.createdDate}]` : '';
      const qty = po.qty ? ` (Qty ${po.qty})` : '';
      return (
        <div className={className} onClick={() => selectPO(po.id, po.qty)} key={po.id}>
          <strong>{po.purchaseOrder}</strong>
          {`${lineNumber}${qty}${createdDate}${customer}`}
          {isSelected === true && <i className="zmdi zmdi-check" />}
          {disabled === true && <Badge>Already Used</Badge>}
        </div>
      );
    });
  };

  if (!list.length) {
    return <FileNotFound>No Purchase Orders Found</FileNotFound>;
  }

  return (
    <div>
      <div className="po-header">Select a Purchase Order</div>
      <div className="po-list">{listPOs()}</div>
    </div>
  );
};

PurchaseOrderPane.propTypes = {
  initialPO: PropTypes.string,
  isAvailable: PropTypes.func,
  list: PropTypes.array,
  onChange: PropTypes.func,
};

export default PurchaseOrderPane;
